import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { connect } from 'react-redux';
import { StickyContainer } from 'react-sticky';

import * as BackstageConstants from '../../constants';
import * as D from '../../deps';

import BackstageLargeHeaderLayout from './BackstageLargeHeaderLayout';

/*
  Determines layout type to show based on what UI component is passed.
  Also gathers common props and handles common actions
*/
export const LayoutManager = props => {
  const { integration } = useContext(D.AppContext);

  const {
    pandoraId,
    name,
    bio,
    shareableUrlPath,
    isMobileDevice,
    playResumeSource,
    heroImageUrl,
    mainContent,
    sidebarButtons,
    subTitleLrg,
    subTitleSm,
    largeHeader,
    isHeaderInSidebar,
    hasCuratorPrograms,
  } = props;

  const headerProps = {
    title: name,
    titleUrl: shareableUrlPath,
    disableHover: isMobileDevice,
    subTitleLrg,
    subTitleSm,
    isHeaderInSidebar,
  };

  const mobilePlayButtonOnClick = () => {
    playResumeSource({
      id: pandoraId,
      context: D.Constants.Ads.Rewards.ContextTypes.BACKSTAGE,
      pageUrl: shareableUrlPath,
    });

    integration.action.clicked({
      pandoraId,
      contentSection: BackstageConstants.BackstageSections.CONTROL_BAR,
      componentEventType: BackstageConstants.BackstageEvents.play,
    });
  };

  if (largeHeader) {
    const renderSidebarButtons = () => sidebarButtons;
    const renderMainContent = () => mainContent;
    return (
      <StickyContainer>
        <BackstageLargeHeaderLayout
          headerBackstage={<D.HeaderBackstageWithLogger {...headerProps} />}
          heroImageUrl={heroImageUrl}
          heroImageLinkUrl={shareableUrlPath}
          heroImageIsCircle={true}
          renderSidebarButtons={renderSidebarButtons}
          renderMainContent={renderMainContent}
          entityIdentifier={pandoraId}
          renderArtworkPlayButton={isMobileDevice}
          playOnClick={mobilePlayButtonOnClick}
          artistBio={bio}
          largeHeader={largeHeader}
        />
      </StickyContainer>
    );
  }

  // Default Backstage Layout
  return (
    <D.BackstageLayout2
      entityIdentifier={pandoraId}
      headerProps={headerProps}
      heroImageUrl={heroImageUrl}
      heroImageIsCircle={true}
      renderArtworkPlayButton={isMobileDevice}
      playOnClick={mobilePlayButtonOnClick}
      sidebarButtons={sidebarButtons}
      mainContent={mainContent}
      isHeaderInSidebar={isHeaderInSidebar}
      hasCuratorPrograms={hasCuratorPrograms}
    />
  );
};

LayoutManager.propTypes = {
  pandoraId: PropTypes.string,
  name: PropTypes.string,
  bio: PropTypes.node,
  shareableUrlPath: PropTypes.string,
  isMobileDevice: PropTypes.bool,
  playResumeSource: PropTypes.func,
  heroImageUrl: PropTypes.string,
  mainContent: PropTypes.node,
  sidebarButtons: PropTypes.node,
  subTitleLrg: PropTypes.node,
  subTitleSm: PropTypes.node,
  largeHeader: PropTypes.node,
  isHeaderInSidebar: PropTypes.bool,
  hasCuratorPrograms: PropTypes.bool,
};

export function mapStateToProps(state, ownProps) {
  const isCuratorExperienceEnabled = D.Utils.TunerVars.curatorExperienceEnabled(state);
  if (isCuratorExperienceEnabled) {
    return {};
  }
  const { pandoraId } = ownProps;
  const annotation = D.getAnnotationsById(state, pandoraId) || BackstageConstants.emptyMap;

  return {
    name: annotation.get('name', ''),
    shareableUrlPath: annotation.get('shareableUrlPath'),
    heroImageUrl: D.getArt(annotation, 300, state),
  };
}

const mapDispatchToProps = {
  playResumeSource: D.playResumeSource,
};

export default connect(mapStateToProps, mapDispatchToProps)(LayoutManager);
